// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"69":"42b3db7d","224":"1d04725a"}[chunkId] + ".chunk.css";
};